import { CommonModule } from '@angular/common';
import { Component, inject, Input, NgModule, OnInit } from '@angular/core';
import { AccountService, DeviceOrientationEnum, FilesService, ScreenService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';

import { RatingComponent } from '@shared/rating/rating.component';
import { ImageSizeEnum, User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCoverModule } from 'onclass-ui';
import { OnUiCover } from 'onclass-ui/lib/modules/on-ui-cover/on-ui-cover.component';

@Component({
  selector: 'app-teacher-header-details',
  templateUrl: './teacher-header-details.component.html',
  styleUrls: ['../../styles/header-details.scss'],
})
export class TeacherHeaderDetailsComponent extends ChangableComponent implements OnInit {
  // DI
  protected readonly screenService = inject(ScreenService);
  protected readonly deviceService = inject(DeviceDetectorService);

  @Input() set teacher(value) {
    this._teacher = value;
  }

  public get teacher() {
    return this._teacher;
  }

  public _teacher: User;

  public ngOnInit() {}

  public screenClasses() {
    const isPortrait = this.screenService.deviceOrientation === DeviceOrientationEnum.portrait;
    return {
      tablet: this.deviceService.isTablet(),
      mobile: this.deviceService.isMobile(),
      desktop: (!this.deviceService.isTablet() && !this.deviceService.isMobile()) || this.deviceService.isDesktop(),
      portrait: !this.deviceService.isDesktop() && isPortrait,
      landscape: !this.deviceService.isDesktop() && !isPortrait,
    };
  }

  public get cover(): OnUiCover {
    return {
      type: 'avatar',
      img:
        FilesService.getFileBySize(this._teacher?.userpic, ImageSizeEnum.md)?.url ||
        FilesService.getFileUrlBySize(this._teacher?.userpic_id, ImageSizeEnum.md) ||
        this.assetsUrl('https://onclass.com/assets/onclass-logo.svg'),
      title: this.title,
      form: 'circle',
    };
  }

  public get title(): string {
    return AccountService.getUserFullName(this.teacher);
  }
}

@NgModule({
  declarations: [TeacherHeaderDetailsComponent],
  imports: [CommonModule, OnUiCoverModule, RatingComponent],
  exports: [TeacherHeaderDetailsComponent],
})
export class TeacherHeaderDetailsModule {}
